import deskDesktop from "./level2/svgdesk.svg";
import deskMobile from "./level2/svgmob.svg";
import cupIcon from "./level2/Cup.png";
import penIcon from "./level2/Pen.png";
import folderIcon from "./level2/folder.png";
import laptopStandIcon from "./level2/laptop_stand.png";
import filesIcon from "./level2/Files.png";
import calculatorIcon from "./level2/calculator.png";
import notebookIcon from "./level2/note.png";
import headphonesIcon from "./level2/Headphone.png";
import { STAGE1_DESK_PUZZLE_POINTS } from "./stage1DeskOrganizeConstants";

export { STAGE1_DESK_PUZZLE_POINTS };
export const STAGE1_DESK_TABLE_DESKTOP = deskDesktop;
export const STAGE1_DESK_TABLE_MOBILE = deskMobile;

/** Crops empty canvas above the desk in svgmob.svg (414×896 → tighter frame). */
export const STAGE1_DESK_MOBILE_VIEWBOX = "0 225 414 710";
export const STAGE1_DESK_MOBILE_ASPECT_RATIO = "414 / 710";

/** SVG element ids hidden at puzzle start; revealed when the matching target is filled. */
export const STAGE1_DESK_SVG_HIDDEN_TARGETS = [
  "files_tray",
  "blue_file_tray",
  "laptop_stand",
  "pen_holder",
  "cup_tray",
];

/** SVG drag rules: draggable id → drop zone on desk → reveal/hide elements. */
export const STAGE1_DESK_SVG_DRAG_RULES = [
  {
    svgId: "files_1",
    itemId: "sticky_notes",
    correctTarget: "document_tray",
    dropZoneId: "files",
    showIds: ["files_tray"],
    hideIds: ["files"],
  },
  {
    svgId: "files_2",
    itemId: "folder",
    correctTarget: "file_rack",
    dropZoneId: "blue_file",
    showIds: ["blue_file_tray"],
    hideIds: ["blue_file"],
  },
  {
    svgId: "pen_1",
    itemId: "pen",
    correctTarget: "pen_holder",
    dropZoneId: "pen",
    showIds: ["pen_holder"],
    hideIds: ["pen"],
  },
  {
    svgId: "laptop_1",
    itemId: "mouse",
    correctTarget: "laptop_stand",
    dropZoneId: "laptop",
    showIds: ["laptop_stand"],
    hideIds: ["laptop"],
  },
  {
    svgId: "cup_tray1",
    itemId: "coffee_mug",
    correctTarget: "coaster",
    dropZoneId: "cup",
    dropHitPaddingMob: 56,
    showIds: ["cup_tray"],
    alsoShowIds: ["cup"],
    hideIds: [],
  },
  {
    svgId: "drawer_1",
    itemId: "notebook",
    correctTarget: "drawer",
    dropZoneId: "open_drawer",
    showIds: [],
    hideIds: ["open_drawer", "pins", "headphone", "calculator", "notes"],
    alsoPlaceItemIds: ["headphones", "calculator"],
  },
];

/** @deprecated Use STAGE1_DESK_SVG_DRAG_RULES */
export const STAGE1_DESK_SVG_DRAGGABLES = STAGE1_DESK_SVG_DRAG_RULES.map(
  ({ svgId, itemId }) => ({ svgId, itemId })
);

export function isDeskSvgDragItem(itemId) {
  return STAGE1_DESK_SVG_DRAG_RULES.some((entry) => entry.itemId === itemId);
}

export function getDeskSvgDragRuleByDropZone(dropZoneId) {
  return STAGE1_DESK_SVG_DRAG_RULES.find((entry) => entry.dropZoneId === dropZoneId);
}

export function getDeskSvgDragRuleBySvgId(svgId) {
  return STAGE1_DESK_SVG_DRAG_RULES.find((entry) => entry.svgId === svgId);
}

export function getDeskSvgDragRuleByItemId(itemId) {
  return STAGE1_DESK_SVG_DRAG_RULES.find((entry) => entry.itemId === itemId);
}

export const STAGE1_DESK_TARGETS = [
  {
    id: "pen_holder",
    label: "Pen Holder",
    svgRevealId: "pen_holder",
    dropPos: { left: "82.2%", top: "22.2%" },
    dropPosMob: { left: "76.4%", top: "33.7%" },
    dropSize: "md",
  },
  {
    id: "coaster",
    label: "Coaster",
    svgRevealId: "cup_tray",
    dropPos: { left: "58.2%", top: "47.9%" },
    dropPosMob: { left: "72.1%", top: "46.2%" },
    dropSize: "sm",
  },
  {
    id: "document_tray",
    label: "Document Tray",
    svgRevealId: "files_tray",
    dropPos: { left: "93.6%", top: "33.8%" },
    dropPosMob: { left: "77.7%", top: "34.2%" },
    dropSize: "md",
  },
  {
    id: "laptop_stand",
    label: "Laptop Stand",
    svgRevealId: "laptop_stand",
    dropPos: { left: "58.5%", top: "22.6%" },
    dropPosMob: { left: "56%", top: "41.1%" },
    dropSize: "md",
  },
  {
    id: "file_rack",
    label: "File Rack",
    svgRevealId: "blue_file_tray",
    dropPos: { left: "81.2%", top: "47.8%" },
    dropPosMob: { left: "85%", top: "51.5%" },
    dropSize: "md",
  },
  {
    id: "drawer",
    label: "Drawer",
    dropPos: { left: "23.4%", top: "52.5%" },
    dropPosMob: { left: "17.2%", top: "47.5%" },
    dropSize: "lg",
  },
];

export const STAGE1_DESK_ITEMS = [
  {
    id: "pen",
    label: "Pen",
    icon: penIcon,
    dotColor: "#3b82f6",
    correctTarget: "pen_holder",
    deskPos: { left: "15.5%", top: "80.8%" },
    deskPosMob: { left: "15.2%", top: "52.3%" },
    deskSize: "sm",
  },
  {
    id: "notebook",
    label: "Notebook",
    icon: notebookIcon,
    dotColor: "#22c55e",
    correctTarget: "drawer",
    deskPos: { left: "9.5%", top: "20.8%" },
    deskPosMob: { left: "19.3%", top: "28.7%" },
    deskSize: "lg",
  },
  {
    id: "coffee_mug",
    label: "Coffee Mug",
    icon: cupIcon,
    dotColor: "#eab308",
    correctTarget: "coaster",
    deskPos: { left: "63%", top: "45.8%" },
    deskPosMob: { left: "95.7%", top: "40.7%" },
    deskSize: "md",
  },
  {
    id: "calculator",
    label: "Calculator",
    icon: calculatorIcon,
    dotColor: "#ef4444",
    correctTarget: "drawer",
    deskPos: { left: "27%", top: "58%" },
    deskPosMob: { left: "46.8%", top: "43.7%" },
    deskSize: "md",
  },
  {
    id: "headphones",
    label: "Headphones",
    icon: headphonesIcon,
    dotColor: "#3b82f6",
    correctTarget: "drawer",
    deskPos: { left: "34%", top: "9.6%" },
    deskPosMob: { left: "59.1%", top: "23.7%" },
    deskSize: "lg",
  },
  {
    id: "folder",
    label: "Folder",
    icon: folderIcon,
    dotColor: "#22c55e",
    correctTarget: "file_rack",
    deskPos: { left: "90.5%", top: "86.7%" },
    deskPosMob: { left: "95.5%", top: "58.3%" },
    deskSize: "lg",
  },
  {
    id: "mouse",
    label: "Laptop Stand",
    icon: laptopStandIcon,
    dotColor: "#eab308",
    correctTarget: "laptop_stand",
    deskPos: { left: "81%", top: "37%" },
    deskPosMob: { left: "95.5%", top: "32%" },
    deskSize: "sm",
  },
  {
    id: "sticky_notes",
    label: "Sticky Notes",
    icon: filesIcon,
    dotColor: "#eab308",
    correctTarget: "document_tray",
    deskPos: { left: "37.5%", top: "88%" },
    deskPosMob: { left: "59.3%", top: "55.7%" },
    deskSize: "sm",
  },
];

export function getDeskItemById(id) {
  return STAGE1_DESK_ITEMS.find((item) => item.id === id);
}

export function getDeskTargetById(id) {
  return STAGE1_DESK_TARGETS.find((target) => target.id === id);
}

export function validateDeskOrganize(placements) {
  const misplaced = STAGE1_DESK_ITEMS.filter(
    (item) => placements[item.id] !== item.correctTarget
  );
  return {
    valid: misplaced.length === 0,
    misplaced,
    allPlaced: STAGE1_DESK_ITEMS.every((item) => placements[item.id]),
  };
}
